import store from '@/store';



const goToDefaultPage = {
  redirect() {
    const { route } = store.state.session;

    window.location.replace(`/${route.merchantId}/welcome?merchantLocationId=${route.merchantLocationId}`);
  },

  shouldShowButton() {
    if (store.state.session.route.merchantLocationId) {
      return true;
    }

    return false;
  }
};



export default goToDefaultPage;
